import { Box, Tooltip } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import {
  getStatusColumnObject,
  handleDoubleClickEvent,
  processRowUpdateForStatusOnly,
  SPEND_COLUMNS
} from './SupplierDataGridUtils';

import { useCallback } from 'react';
import { STRATEGIC } from '../../shared/AppConstants';
import { supplierDataGridSx } from './supplierDataGridStyles';

function getSplrColumns(isEdit, strategicOrNonStrategic) {
  let cols = [
    {
      field: 'number',
      headerName: 'Number',
      width: 125,
      renderCell: (params) => {
        const isBlockedSupplier = params.row.activeSupplier === 'N';
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span>{params.value}</span>
            {isBlockedSupplier && (
              <Tooltip title="Blocked">
                <Box
                  component="span"
                  sx={(theme) => ({
                    color: theme.fuel6Tokens.JddcColorIconError,
                    marginLeft: '0.25em',
                    display: 'inline-flex'
                  })}
                >
                  <fuel-icon name="do_not_disturb_on" />
                </Box>
              </Tooltip>
            )}
          </div>
        );
      }
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 475
    },
    {
      ...getStatusColumnObject(isEdit, strategicOrNonStrategic),
      width: 125
    },
    ...SPEND_COLUMNS
  ];

  return cols;
}

export function ByUnitsUnitDetailPanelContent({
  row,
  updateSupplierStatus,
  isEdit
}) {
  const handleCellClick = useCallback(
    (params, event) => handleDoubleClickEvent(params, event),
    []
  );

  return (
    <Box sx={{ ml: 12 }}>
      <DataGridPro
        density="compact"
        initialState={{
          sorting: {
            sortModel: [{ field: 'r12Spend', sort: 'desc' }]
          }
        }}
        processRowUpdate={(updatedRow) => {
          return processRowUpdateForStatusOnly(
            updatedRow,
            updateSupplierStatus
          );
        }}
        columns={getSplrColumns(isEdit, STRATEGIC)}
        rows={row.suppliersSpend}
        onCellClick={handleCellClick}
        hideFooter
        sx={supplierDataGridSx}
      />
    </Box>
  );
}
